/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Support',
    lead: 'Alle Support-Tickets der Plattform, filterbar nach Status und Priorität.',
    filterStatus: 'Status',
    filterPriority: 'Priorität',
    allStatuses: 'Alle Status',
    allPriorities: 'Alle Prioritäten',
    empty: 'Keine Tickets entsprechen diesen Filtern.',
    rowsLabel: 'die Tickets',
    subject: 'Betreff',
    company: 'Unternehmen',
    status: 'Status',
    priority: 'Priorität',
    createdAt: 'Eröffnet',
  },
  status: {
    open: 'Offen',
    in_progress: 'In Bearbeitung',
    resolved: 'Gelöst',
    closed: 'Geschlossen',
  },
  priority: {
    low: 'Niedrig',
    normal: 'Normal',
    high: 'Hoch',
    urgent: 'Dringend',
  },
  detail: {
    thisTicket: 'dieses Ticket',
    requesterTitle: 'Anfragende Person',
    requesterLabel: 'die anfragende Person',
    controlsTitle: 'Status & Priorität',
    save: 'Speichern',
    threadTitle: 'Verlauf',
    threadEmpty: 'Noch keine Nachrichten.',
    replyLabel: 'Antwort',
    reply: 'Antwort senden',
  },
} as const;
